// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__2IKCU","closeModal":"styles_closeModal__cG-hE","modalContainer":"styles_modalContainer__2YoUu","p":"styles_p__3c56I","span":"styles_span__baqqK"};